import React from 'react';

import {
  Button,
  Stack,
  Typography
} from '@mui/material';
import {
  AuthWrapper,
  BaseOnboardingTemplate,
  imageUtil,
  ResponsiveImage,
  routeDirectory
} from 'modules';
import { useNavigate } from 'react-router-dom';



const imgsTarget = imageUtil.getUrlSet('target','png');



export const OnboardingCompleteActivity: React.FC = () => {
  const navigate = useNavigate();



  return (
    <AuthWrapper.FC>
      <BaseOnboardingTemplate.FC stepperMode="complete">
        <Stack
          spacing={5}
          alignItems="center">
          <ResponsiveImage.FC
            urlSet={imgsTarget}
            width="190px"
            height="auto" />

          <Stack
            alignItems="center"
            spacing={2}>
            <Typography variant="h1">
              You are all set!
            </Typography>

            <Typography>
              You now have full access to your Ridge account.
            </Typography>
          </Stack>

          <Button
            variant="contained"
            onClick={() => {
              navigate(routeDirectory.home.path());
            }}>
            Get Started
          </Button>
        </Stack>
      </BaseOnboardingTemplate.FC>
    </AuthWrapper.FC>
  );
};
